const TOPIC = 'topic';

type ticketInputs = {
	topicId: string;
	subTopicId: string;
	transactionId?: number;
	entryFee?: string;
	description: string;
};

export const TOPIC_NAMES = {
	TRANSACTION_ENTRYFEE_N_WINNINGS: 'TRANSACTION_ENTRYFEE_N_WINNINGS',
	ENTRY_FEE_REFUND: 'ENTRY_FEE_REFUND',
	TRANSACTION_REFERRAL: 'TRANSACTION_REFERRAL',
	WALLET_N_PAYMENTS: 'WALLET_N_PAYMENTS',
	REFERRALS: 'REFERRALS',
	OTHER_ISSUES: 'OTHER_ISSUES',
	TRANSACTION_DEPOSIT: 'TRANSACTION_DEPOSIT',
	GAME_RELATED: 'GAME_RELATED',
	TRANSACTION_DEPOSIT_OFFER: 'TRANSACTION_DEPOSIT_OFFER',
	LOGIN: 'LOGIN',
	TRANSACTION_WITHDRAWAL: 'TRANSACTION_WITHDRAWAL',
	KYC: 'KYC',
	LUDO_MAHASANGRAM: 'LUDO_MAHASANGRAM',
	TRANSACTION_PENDING_DEPOSIT: 'TRANSACTION_PENDING_DEPOSIT',
	ACCOUNT_DELETION: 'ACCOUNT_DELETION',
	TDS_RELATED: 'TDS_RELATED'
};
export const topicSubtopicMap = {
	[TOPIC_NAMES.TRANSACTION_ENTRYFEE_N_WINNINGS]: [
		'GAMEPLAY_SUGGESTION',
		'GAME_DID_NOT_START',
		'GAMEPLAY_ISSUE',
		'GAME_CLOSED',
		'FAILED_REFUND',
		'BANNED_STATES',
		'TOURNAMENT_INVOICE'
	],
	[TOPIC_NAMES.ENTRY_FEE_REFUND]: ['FAILED_REFUND', 'GAME_CLOSED', 'GAME_DID_NOT_START', 'OTHER_ISSUES'],
	[TOPIC_NAMES.TRANSACTION_REFERRAL]: ['REFERRAL_ISSUES', 'REFERRAL_BONUS', 'OTHER_ISSUES'],
	[TOPIC_NAMES.WALLET_N_PAYMENTS]: [
		'BANK_WITHDRAWAL',
		'COUPON_FAILED',
		'UPI_WITHDRAWAL',
		'OTHER_ISSUES',
		'WALLET_UPDATE',
		'BANK_UPI_DETAILS_NOT_VISIBLE',
		'BANNED_STATE_WITHDRAWAL'
	],
	[TOPIC_NAMES.REFERRALS]: ['REFERRAL_BONUS', 'OTHER_ISSUES'],
	[TOPIC_NAMES.OTHER_ISSUES]: ['TOURNAMENT_NOT_VISIBLE', 'OTHER_ISSUES', 'WEIRD_ISSUE', 'SUGGESTION', 'TOURNAMENT_INVOICE'],
	[TOPIC_NAMES.TRANSACTION_DEPOSIT]: ['PAYMENT_ISSUES', 'WALLET_UPDATE', 'TOURNAMENT_NOT_VISIBLE', 'OTHER_ISSUES', 'COUPON_FAILED'],
	[TOPIC_NAMES.GAME_RELATED]: ['GAME_CLOSED', 'FAILED_REFUND', 'BANNED_STATES', 'GAME_DID_NOT_END', 'TOKENS_STUCK', 'OTHER_ISSUES'],
	[TOPIC_NAMES.TRANSACTION_DEPOSIT_OFFER]: ['COUPON_FAILED', 'PAYMENT_ISSUES', 'OTHER_ISSUES'],
	[TOPIC_NAMES.LOGIN]: ['SIGNUP', 'OTHER_ISSUES'],
	[TOPIC_NAMES.TRANSACTION_WITHDRAWAL]: ['BANK_WITHDRAWAL', 'PAYMENT_ISSUES', 'OTHER_ISSUES', 'UPI_WITHDRAWAL'],
	[TOPIC_NAMES.KYC]: [
		'DRIVING_LICENSE_REJECTED',
		'VOTER_ID_CARD_REJECTED',
		'PENDING_KYC',
		'OTHER_ISSUES',
		'PAN_CARD_REJECTED',
		'MANUAL_KYC_VERIFY'
	],
	[TOPIC_NAMES.LUDO_MAHASANGRAM]: ['ROUND_WON_BUT_KICKED_OUT', 'REWARD_ISSUES', 'SIGNED_UP_BUT_COULDNT_PLAY'],
	[TOPIC_NAMES.TRANSACTION_PENDING_DEPOSIT]: [
		'COUPON_FAILED',
		'PAYMENT_ISSUES',
		'OTHER_ISSUES',
		'TOURNAMENT_NOT_VISIBLE',
		'WALLET_UPDATE'
	],
	[TOPIC_NAMES.ACCOUNT_DELETION]: ['PERMANENT_ACCOUNT_DELETION'],
	[TOPIC_NAMES.TDS_RELATED]: ['TDS_INFO']
};

export const TOPIC_NAME_OPTIONS = {
	[TOPIC_NAMES.TRANSACTION_ENTRYFEE_N_WINNINGS]: 'TRANSACTION_ENTRYFEE_N_WINNINGS',
	[TOPIC_NAMES.ENTRY_FEE_REFUND]: 'ENTRY_FEE_REFUND',
	[TOPIC_NAMES.TRANSACTION_REFERRAL]: 'TRANSACTION_REFERRAL',
	[TOPIC_NAMES.WALLET_N_PAYMENTS]: 'WALLET_N_PAYMENTS',
	[TOPIC_NAMES.REFERRALS]: 'REFERRALS',
	[TOPIC_NAMES.OTHER_ISSUES]: 'OTHER_ISSUES',
	[TOPIC_NAMES.TRANSACTION_DEPOSIT]: 'TRANSACTION_DEPOSIT',
	[TOPIC_NAMES.GAME_RELATED]: 'GAME_RELATED',
	[TOPIC_NAMES.TRANSACTION_DEPOSIT_OFFER]: 'TRANSACTION_DEPOSIT_OFFER',
	[TOPIC_NAMES.LOGIN]: 'LOGIN',
	[TOPIC_NAMES.TRANSACTION_WITHDRAWAL]: 'TRANSACTION_WITHDRAWAL',
	[TOPIC_NAMES.KYC]: 'KYC',
	[TOPIC_NAMES.LUDO_MAHASANGRAM]: 'LUDO_MAHASANGRAM',
	[TOPIC_NAMES.TRANSACTION_PENDING_DEPOSIT]: 'TRANSACTION_PENDING_DEPOSIT',
	[TOPIC_NAMES.ACCOUNT_DELETION]: 'ACCOUNT_DELETION',
	[TOPIC_NAMES.TDS_RELATED]: 'TDS_RELATED'
};

export const TOPIC_NAME_LABLES = {
	[TOPIC_NAMES.TRANSACTION_ENTRYFEE_N_WINNINGS]: 'TRANSACTION_ENTRYFEE_N_WINNINGS',
	[TOPIC_NAMES.ENTRY_FEE_REFUND]: 'ENTRY_FEE_REFUND',
	[TOPIC_NAMES.TRANSACTION_REFERRAL]: 'TRANSACTION_REFERRAL',
	[TOPIC_NAMES.WALLET_N_PAYMENTS]: 'WALLET_N_PAYMENTS',
	[TOPIC_NAMES.REFERRALS]: 'REFERRALS',
	[TOPIC_NAMES.OTHER_ISSUES]: 'OTHER_ISSUES',
	[TOPIC_NAMES.TRANSACTION_DEPOSIT]: 'TRANSACTION_DEPOSIT',
	[TOPIC_NAMES.GAME_RELATED]: 'GAME_RELATED',
	[TOPIC_NAMES.TRANSACTION_DEPOSIT_OFFER]: 'TRANSACTION_DEPOSIT_OFFER',
	[TOPIC_NAMES.LOGIN]: 'LOGIN',
	[TOPIC_NAMES.TRANSACTION_WITHDRAWAL]: 'TRANSACTION_WITHDRAWAL',
	[TOPIC_NAMES.KYC]: 'KYC',
	[TOPIC_NAMES.LUDO_MAHASANGRAM]: 'LUDO_MAHASANGRAM',
	[TOPIC_NAMES.TRANSACTION_PENDING_DEPOSIT]: 'TRANSACTION_PENDING_DEPOSIT',
	[TOPIC_NAMES.ACCOUNT_DELETION]: 'ACCOUNT_DELETION',
	[TOPIC_NAMES.TDS_RELATED]: 'TDS_RELATED'
};

export { TOPIC };

export type { ticketInputs };
